import seasonListStore from '@modules/season/season-list-store';
import seasonViewStore from '@modules/season/season-view-store';
import seasonImporterStore from '@modules/season/season-importer-store';
import seasonFormStore from '@modules/season/season-form-store';
import seasonDestroyStore from '@modules/season/season-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: seasonDestroyStore,
    form: seasonFormStore,
    list: seasonListStore,
    view: seasonViewStore,
    importer: seasonImporterStore,
  },
};
